import React from 'react'
import Grid from '@material-ui/core/Grid';
import { getCookie } from '../../utils/CookieHelper';
import Service from '../../config/networkutils'
import { LoopCircleLoading } from 'react-loadingg';
import { getPrimaryColor } from '../Helper/CommonThings';
import CRMInputTable from './CRMInputTable';

const account_name_api = "/api/ptd/account/get_with_delete_status/";
const account_name_api_bulk_update = "/api/ptd/account/bulk_update";
const sales_stage_api = "/api/salesstage/get_sales_stage_data/";
const gate_stage_api = "/api/gatestages/get_gate_stage_data/";
const sub_sector_api = "/api/subsector/get_with_delete_status/";
const sub_sector_api_bulk_update = "/api/subsector/bulk_update";
const market_sub_vertical_api = "/api/marketsubvertical/get_market_subvertical_data/";
const owner_delivery_api = "/api/ownerdelivery/get_with_delete_status/";
const owner_delivery_api_bulk_update = "/api/ownerdelivery/bulk_update";
const owner_region_sector = "/api/ownerregionsector/get_with_delete_status/";
const owner_region_sector_bulk_update = "/api/ownerregionsector/bulk_update";
const opportunity_type_api = "/api/opportunitytype/get_opportunity_type_data/";

const post_sales_stage_api = "/api/salesstage/";
const post_gate_stage_api = "/api/gatestages/";
const post_market_sub_vertical_api = "/api/marketsubvertical/";
const post_opportunity_type_api = "/api/opportunitytype/";

const columns = [
    { title: 'Id', field: 'id', editable: 'never' },
    {
        title: 'Name', field: 'name',
    },
]

const token = getCookie("ptd_ts_token");

class TableContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            data: {}
        }
    }

    componentDidMount() {
        this.fetchData()
    }

    fetchData() {
        this.setState({ isLoading: true });
        let api = `/api/ptd/account/get_crm_inputs_data/?client=true&sales_stage=true&gate_stage=true&discipline=true&division=true&operations_lead=true&sub_division=true&opportunity_type=true`;
        Service.get(api, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                this.setState({
                    data: res.data,
                    isLoading: false
                })
            })
            .catch(error => {
                console.log(error)
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error',
                });
            });
    }

    render() {
        return (
            <div>
                {
                    this.state.isLoading ? <LoopCircleLoading color={getPrimaryColor()} /> :
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6}>
                                <div style={{ height: '70vh', overflowY: 'auto' }}>
                                    <CRMInputTable
                                        tableName="Client Name"
                                        api={account_name_api}
                                        bulk_update_api={account_name_api_bulk_update}
                                        upload={false}
                                        access={this.props.access}
                                        deletable={true}
                                        isActive={this.props.isActive}
                                        columns={columns}
                                        data={this.state.data ? this.state.data.client : []}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div style={{ height: '70vh', overflowY: 'auto' }}>
                                    <CRMInputTable
                                        tableName="Sales Stage"
                                        api={sales_stage_api}
                                        post_api={post_sales_stage_api}
                                        upload={false}
                                        access={this.props.access}
                                        columns={columns}
                                        isActive={this.props.isActive}
                                        detailPanel={true}
                                        salesStage={true}
                                        link_get_api={`/api/crm/salestage/segregation/get_crm_sales_stage_segregation/?sales_stage=`}
                                        link_post_api={'/api/crm/salestage/segregation/link_and_delink_sales_stages/'}
                                        data={this.state.data ? this.state.data.sales_stage : []}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div style={{ height: '70vh', overflowY: 'auto' }}>
                                    <CRMInputTable
                                        tableName="Gate Stages"
                                        api={gate_stage_api}
                                        post_api={post_gate_stage_api}
                                        upload={false}
                                        access={this.props.access}
                                        columns={columns}
                                        isActive={this.props.isActive}
                                        detailPanel={true}
                                        gateStage={true}
                                        link_get_api={`/api/crm/gatestage/segregation/get_crm_gatestage_segregation/?gate_stage=`}
                                        link_post_api={'/api/crm/gatestage/segregation/link_and_delink_gate_stages/'}
                                        data={this.state.data ? this.state.data.gate_stage : []}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div style={{ height: '70vh', overflowY: 'auto' }}>
                                    <CRMInputTable
                                        tableName="Discipline"
                                        api={sub_sector_api}
                                        upload={false}
                                        bulk_update_api={sub_sector_api_bulk_update}
                                        access={this.props.access}
                                        deletable={true}
                                        isActive={this.props.isActive}
                                        columns={columns}
                                        data={this.state.data ? this.state.data.discipline : []}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div style={{ height: '70vh', overflowY: 'auto' }}>
                                    <CRMInputTable
                                        tableName="Division"
                                        api={market_sub_vertical_api}
                                        post_api={post_market_sub_vertical_api}
                                        upload={false}
                                        access={this.props.access}
                                        isActive={this.props.isActive}
                                        columns={columns}
                                        data={this.state.data ? this.state.data.division : []}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div style={{ height: '70vh', overflowY: 'auto' }}>
                                    <CRMInputTable
                                        tableName="Operations Lead"
                                        api={owner_delivery_api}
                                        bulk_update_api={owner_delivery_api_bulk_update}
                                        upload={false}
                                        access={this.props.access}
                                        deletable={true}
                                        isActive={this.props.isActive}
                                        columns={columns}
                                        data={this.state.data ? this.state.data.operations_lead : []}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div style={{ height: '70vh', overflowY: 'auto' }}>
                                    <CRMInputTable
                                        tableName="Sub Division"
                                        api={owner_region_sector}
                                        bulk_update_api={owner_region_sector_bulk_update}
                                        upload={false}
                                        access={this.props.access}
                                        deletable={true}
                                        isActive={this.props.isActive}
                                        columns={columns}
                                        data={this.state.data ? this.state.data.sub_division : []}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div style={{ height: '70vh', overflowY: 'auto' }}>
                                    <CRMInputTable
                                        tableName="Opportunity Type"
                                        api={opportunity_type_api}
                                        post_api={post_opportunity_type_api}
                                        upload={false}
                                        access={this.props.access}
                                        isActive={this.props.isActive}
                                        columns={columns}
                                        data={this.state.data ? this.state.data.opportunity_type : []}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                }
            </div>
        );
    }
}

export default TableContainer;
